
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32 16c0-8.837-7.163-16-16-16S0 7.163 0 16s7.163 16 16 16 16-7.163 16-16zm-13.171-5.697c-.738-.034-.96-.041-2.829-.041-1.869 0-2.09.007-2.828.04-.683.032-1.053.146-1.3.242-.327.127-.56.278-.805.523a2.168 2.168 0 00-.524.805c-.095.247-.21.617-.24 1.3-.034.738-.041.96-.041 2.828 0 1.87.007 2.09.04 2.829.032.683.146 1.053.242 1.3.127.327.278.56.523.805s.478.396.805.523c.247.096.617.21 1.3.241.738.034.96.041 2.828.041 1.87 0 2.091-.007 2.829-.04.683-.032 1.053-.146 1.3-.242a2.17 2.17 0 00.805-.523 2.17 2.17 0 00.523-.805c.096-.247.21-.617.241-1.3.034-.738.041-.96.041-2.829 0-1.869-.007-2.09-.04-2.828-.032-.683-.146-1.053-.242-1.3a2.17 2.17 0 00-.523-.805 2.17 2.17 0 00-.805-.524c-.247-.095-.617-.21-1.3-.24zm-5.715-1.26C13.86 9.007 14.099 9 16 9c1.901 0 2.14.008 2.886.042.745.034 1.254.152 1.7.326.46.178.85.418 1.24.807.388.389.628.78.806 1.24.173.445.292.954.326 1.699.034.746.042.985.042 2.886 0 1.901-.008 2.14-.042 2.886-.034.745-.152 1.254-.325 1.7a3.43 3.43 0 01-.808 1.24c-.389.388-.78.628-1.24.806-.445.174-.954.292-1.699.326-.746.034-.985.042-2.886.042-1.901 0-2.14-.008-2.886-.042-.745-.034-1.254-.152-1.7-.325a3.432 3.432 0 01-1.24-.808 3.43 3.43 0 01-.806-1.24c-.174-.445-.292-.954-.326-1.699C9.008 18.14 9 17.901 9 16c0-1.901.008-2.14.042-2.886.034-.745.152-1.254.325-1.7.18-.46.419-.85.808-1.24.389-.388.78-.628 1.24-.806.445-.174.954-.292 1.699-.326zM16 12.454a3.545 3.545 0 100 7.09 3.545 3.545 0 000-7.09zm0 5.847a2.301 2.301 0 110-4.603 2.301 2.301 0 010 4.603zM20 13a1 1 0 100-2 1 1 0 000 2z","fill":"currentColor"}})])
          )
        }
      }
    